// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartlineContainerStyles } from "@pace/App/Components/Cart/CartLineContainer";
import { color, getSystemColor, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

cartlineContainerStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 91px minmax(0, 267px) minmax(0, 143px) minmax(0, 138px) minmax(0, 111px) minmax(0, 135px) minmax(
                0,
                12px
            );
        grid-column-gap: 12px;

        width: 100%;
        background: ${color("common.background")};
        border-bottom: 1px solid ${color("common.border")};
        padding: 20px 12px;

        @media print {
            width: 100%;
            content: "";
            display: table;
            clear: both;
            -webkit-column-break-inside: avoid;
            page-break-inside: avoid;
            break-inside: avoid;
            border-top: 1px solid ${getSystemColor("common.border")};
        }

        ${xScreen("lte", "md")} {
            grid-row-gap: 12px;
        }
    `,
};
cartlineContainerStyles.image = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 1 / 4;
        ${xScreen("lte", "md")} {
            grid-row: 1 / 2;
        }
        @media print {
            min-width: 120px;
            min-height: 120px;
            margin-bottom: 0;
            float: left;
        }
    `,
};
cartlineContainerStyles.description = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 1 / 2;
        position: relative;
        margin-bottom: 8px;
        gap: 8px;
        display: flex;
        flex-direction: column;
        & > .brand-description-wrapper {
            display: flex;
            flex-direction: column;
        }
        ${xScreen("lte", "md")} {
            grid-column: 2 / 7;
            grid-row: 1 / 2;
            margin-bottom: 0;
        }
        @media print {
            min-width: 70%;
            max-width: 70%;
            min-height: 120px;
            float: right;
            display: block;
        }
    `,
};
cartlineContainerStyles.availability = {
    css: css`
        grid-column: 3 / 4;
        grid-row: 1 / 2;
        position: relative;
        padding-top: 9px;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 4;
            grid-row: 2 / 3;
            padding-top: 0;
        }

        @media print {
            min-width: 100%;
            min-height: 50px;
            float: left;
        }
    `,
};
cartlineContainerStyles.price = {
    css: css`
        grid-column: 4 / 5;
        grid-row: 1 / 2;
        position: relative;
        padding-top: 6px;
        ${xScreen("lte", "md")} {
            grid-column: 4 / 8;
            grid-row: 2 / 3;
            padding-top: 0;
        }

        @media print {
            min-width: 30%;
            min-height: 50px;
            float: left;
        }
    `,
};
cartlineContainerStyles.qty = {
    css: css`
        grid-column: 5 / 6;
        grid-row: 1 / 2;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 4;
            grid-row: 3 / 4;
            margin-right: 20px;
        }

        @media print {
            margin-right: 0;
            min-width: 35%;
            min-height: 50px;
            float: left;
        }
    `,
};
cartlineContainerStyles.total = {
    css: css`
        grid-column: 6 / 7;
        grid-row: 1 / 2;
        position: relative;
        padding-top: 6px;
        ${xScreen("lte", "md")} {
            grid-column: 4 / 8;
            grid-row: 3 / 4;
            padding-top: 0;
        }

        @media print {
            min-width: 30%;
            min-height: 50px;
            float: right;
        }
    `,
};
cartlineContainerStyles.remove = {
    css: css`
        grid-column: 7 / 8;
        grid-row: 1 / 2;
        padding-top: 6px;
        ${xScreen("lte", "md")} {
            padding-top: 0;
            grid-row: 1 / 2;
            grid-column: 7 / 8;
        }
    `,
};
cartlineContainerStyles.actions = {
    css: css`
        grid-column: 2 / 4;
        grid-row: 2 / 3;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 8;
            grid-row: 4 / 5;
            justify-content: flex-end;
            gap: 12px;
        }

        @media print {
            display: block;
            & > :not(.replacment-link-wrapper) {
                display: none;
            }
        }
    `,
};
cartlineContainerStyles.notes = {
    css: css`
        grid-column: 2 / 8;
        grid-row: 3 / 4;
        position: relative;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 8;
            grid-row: 5 / 6;
        }

        @media print {
            min-width: 100%;
            float: left;
        }
    `,
};
